/**
 * Cart reservation countdown shown at the top of the cart drawer.
 * Starts when the drawer is first rendered, survives re-renders and page loads (localStorage),
 * and hides itself when the time is up.
 */
class ScCartTimer extends HTMLElement {
  connectedCallback() {
    const key = 'sc_cart_timer_end';
    const duration = (parseInt(this.dataset.minutes || '15', 10) || 15) * 60000;
    const now = Date.now();
    let end = 0;
    try {
      end = parseInt(localStorage.getItem(key) || '0', 10) || 0;
    } catch (error) {
      end = 0;
    }
    if (!end || end < now - 24 * 60 * 60000) {
      end = now + duration;
      try {
        localStorage.setItem(key, String(end));
      } catch (error) {
        /* storage unavailable: the timer simply restarts on the next render */
      }
    }
    this.end = end;
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const left = this.end - Date.now();
    if (left <= 0) {
      this.hidden = true;
      clearInterval(this.interval);
      return;
    }
    const minutes = Math.floor(left / 60000);
    const seconds = Math.floor((left % 60000) / 1000);
    const label = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    const target = this.querySelector('[data-timer]');
    if (target) target.textContent = label;
  }
}

if (!customElements.get('sc-cart-timer')) {
  customElements.define('sc-cart-timer', ScCartTimer);
}
